import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../components/Blog.css";

const BlogDetails = () => {

  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Adobe PDF Tools: Features, Benefits & Future Innovations
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

                <img src="/graphics/images/Adobe_pdf.png" alt="Adobe PDF Tools" />

                <h2>Introduction</h2>
                <p>
                  In today’s digital landscape, efficient document management is essential for individuals 
                  and businesses. One of the most widely used file formats is the Portable Document Format (PDF), 
                  developed by Adobe. Adobe PDFs have changed the way documents are shared, stored, and secured, 
                  making them a crucial tool for professionals across different industries.
                </p>

                <h2>The Origin of Adobe PDF</h2>
                <p>
                  Introduced in 1993, Adobe’s PDF format was designed to provide a reliable way to present and 
                  exchange documents, independent of software or hardware differences. Over the years, it has become a 
                  universal standard for digital documentation due to its accessibility, security, and ease of use.
                </p>

                <h2>Key Benefits of Adobe PDF</h2>

                <h3>1. Cross-Platform Compatibility</h3>
                <p>
                  One of the main advantages of Adobe PDF is its universal compatibility. Whether on Windows, macOS, Linux,
                  or mobile devices, PDF files retain their original format and layout.
                </p>

                <h3>2. Security and Protection</h3>
                <p>
                  With the increasing need for data security, Adobe PDF provides features like encryption, password protection, 
                  and digital signatures, ensuring the safety of sensitive information.
                </p>

                <h3>3. Editing and Conversion Capabilities</h3>
                <p>
                  Using tools like Adobe Acrobat, users can modify text, insert images, and convert PDFs to formats such as Word, Excel, 
                  and PowerPoint, making document handling seamless.
                </p>

                <h3>4. File Size Optimization</h3>
                <p>
                  PDFs can be compressed to reduce file sizes while maintaining quality, making 
                  them easier to share via email and cloud storage.
                </p>

                <h3>5. Streamlined Collaboration</h3>
                <p>
                  Features like annotations, comments, and real-time collaboration help teams work efficiently by allowing 
                  document reviews and feedback directly within the file.
                </p>

                <h2>Adobe PDF Tools and Their Functions</h2>

                <h3>Adobe Acrobat DC</h3>
                <p>
                  A comprehensive solution for creating, editing, signing, and sharing PDFs. It allows users to modify text, add annotations, and convert PDFs to other formats.
                </p>

                <h3>Adobe Scan</h3>
                <p>
                  A mobile application that transforms your smartphone into a scanner, converting images into high-quality PDFs with optical character recognition (OCR).
                </p>

                <h3>Adobe Sign</h3>
                <p>
                  A tool that enables digital signatures for legally binding documents, streamlining electronic approvals and agreements.
                </p>

                <h3>Adobe PDF Pack</h3>
                <p>
                  A bundle of tools that helps users create, merge, and convert PDFs, ideal for professionals and businesses looking for easy document management.
                </p>

                <h3>Adobe AI Assistant</h3>
                <p>
                  An advanced feature that leverages artificial intelligence to summarize, search, and extract key information from PDFs, 
                  making document navigation more efficient.
                </p>

                <h3>Looking Ahead: The Future of Adobe PDF</h3>
                <p>With AI-driven innovations, Adobe continues to improve PDF functionalities. The introduction of tools like Acrobat AI Assistant 
                enhances user experience by making PDF interaction more intuitive and efficient.</p>

                <h2>Conclusion</h2>
                <p>
                  Adobe PDF has transformed digital documentation with its flexibility, security, and ease of use. Whether for professionals, students, 
                  or businesses, it remains an essential tool for efficient document management. As technology evolves, Adobe continues to develop new 
                  features that enhance its capabilities.
                </p>

                <p><b>Are you maximizing the potential of Adobe PDF? Explore its robust features and elevate your document management experience!</b></p>

              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
